import { matchesNextSendDateFilter } from '../../scheduledEmails/filterScheduledEmails';
import { StatementScheduledEmail, StatementScheduleStatus } from './model';

export const STATEMENT_SCHEDULE_STATUS_FILTER_LABELS: Record<StatementScheduleStatus, string> = {
  ready: 'Ready',
  manual_locked: 'Manual locked',
  auto_skipped: 'Auto skipped',
  auto_paused: 'Automatic paused',
  no_recipients: 'No recipients',
};

const STATEMENT_SCHEDULE_STATUSES: StatementScheduleStatus[] = [
  'ready',
  'manual_locked',
  'auto_skipped',
  'auto_paused',
  'no_recipients',
];

export const STATEMENT_SCHEDULE_STATUS_FILTER_OPTIONS = STATEMENT_SCHEDULE_STATUSES.map((status) => ({
  value: status,
  label: STATEMENT_SCHEDULE_STATUS_FILTER_LABELS[status],
}));

export interface StatementScheduledEmailFilterFields {
  company: string;
  nextSendDate: string;
  status: '' | StatementScheduleStatus;
}

export const EMPTY_STATEMENT_FILTERS: StatementScheduledEmailFilterFields = {
  company: '',
  nextSendDate: '',
  status: '',
};

export const filterStatementScheduledEmails = (
  rows: StatementScheduledEmail[],
  filters: StatementScheduledEmailFilterFields,
): StatementScheduledEmail[] => {
  const companyQuery = filters.company.trim().toLowerCase();

  return rows.filter((row) => {
    if (companyQuery && !row.company.toLowerCase().includes(companyQuery)) return false;
    if (filters.status && row.schedule_status !== filters.status) return false;
    if (!matchesNextSendDateFilter(row.next_send_at, filters.nextSendDate)) return false;
    return true;
  });
};
